import Accordion from "./wishlist/accordion";
import GroupFilter from "./wishlist/group-filter";
import PopupNewGroup from "./wishlist/popup-new-group";
import PopupEditGroup from "./wishlist/popup-edit-group";
import GroupEditor from "./wishlist/group-editor";
import ProductEditor from "./wishlist/product-editor";
import PopupNewSection from "./wishlist/popup-new-section";
import PopupEditSection from "./wishlist/popup-edit-section";
import AddToCart from "./wishlist/add-to-cart";
import Share from "./wishlist/share";
import PopupEditProduct from "./wishlist/popup-edit-product";
import PopupExpert from "./wishlist/popup-expert";
import DragDrop from "./wishlist/drag-drop";
import PopupRegisterAccount from "./wishlist/popup-register-account";
import { isSafari } from "./utils/useragent";

class Wishlist {
  private scope: any;

  public wishlistContent: any = JSON.parse(document.getElementById('js-wishlist-content')?.innerHTML as string || '[]');
  public wishlistListShared: any = document.getElementById('js-wishlist-shared') ? JSON.parse(document.getElementById('js-wishlist-shared')?.innerHTML as string) : null;
  public wishlistListTypes: any = JSON.parse(document.getElementById('js-wishlist-list-types')?.innerHTML as string || '[]');

  public formsMove: NodeListOf<HTMLFormElement>;

  constructor() {
    // @ts-ignore
    window.LIST_TYPES = this.wishlistListTypes;

    this.scope = {
      accordion: new Accordion(),
      groupFilter: new GroupFilter(),
      popupNewGroup: new PopupNewGroup(),
      popupEditGroup: new PopupEditGroup(this.wishlistContent),
      groupEditor: new GroupEditor(this.wishlistContent),
      productEditor: new ProductEditor(this.wishlistContent),
      popupNewSection: new PopupNewSection(this.wishlistContent),
      popupEditSection: new PopupEditSection(this.wishlistContent),
      addToCart: new AddToCart(this.wishlistContent),
      share: new Share(this.wishlistContent, this.wishlistListShared),
      popupEditProduct: new PopupEditProduct(this.wishlistContent),
      popupExpert: new PopupExpert(this.wishlistContent),
      dragDrop: new DragDrop(),
      popupRegisterAccount: new PopupRegisterAccount(),
    };
  }

  init() {
    this.scope.accordion.init();
    this.scope.groupFilter.init();
    this.scope.popupNewGroup.init();
    this.scope.popupEditGroup.init();
    this.scope.groupEditor.init();
    this.scope.productEditor.init();
    this.scope.popupNewSection.init();
    this.scope.popupEditSection.init();
    this.scope.addToCart.init();
    this.scope.share.init();
    this.scope.popupEditProduct.init();
    this.scope.popupExpert.init();
    this.scope.dragDrop.init();
    this.scope.popupRegisterAccount.init();

    if (isSafari()) {
      (document.querySelectorAll('.a-wishlist-link-link') as NodeListOf<HTMLElement> | null)?.forEach((el) => el.style.display = 'none');
    }
  }
}

new Wishlist().init();
